import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { DateTime } from "luxon";
import Image from "../../../components/image";
import { getUrl } from "../../../utils/helper";

class Item extends Component {
    renderMain = () => {
        const { item } = this.props;

        return (
            <>
                {item.cover && (
                    <Image
                        alt={item.cover.alt || item.title}
                        url={item.cover.url}
                        aspectRatio="aspect-ratio-4/3"
                        styleExtra="mb-20"
                    />
                )}
                <h1 className={"font-judge font-bold text-30 mb-12"}>
                    {item.title.toUpperCase()}
                </h1>
                {item.subtitle && (
                    <div className={`border-b border-blue pb-24 flex-1`}>
                        <p
                            className={
                                "font-bold text-17 xl:text-23 leading-tight line-clamp-5"
                            }
                        >
                            {item.subtitle}
                        </p>
                    </div>
                )}
                {(item.left || item.right) && (
                    <div className="flex justify-between pt-10">
                        <p className="font-bold text-17">
                            {item.left ? item.left : ""}
                        </p>
                        <p className="font-bold text-17">
                            {item.right ? item.right : ""}
                        </p>
                    </div>
                )}
            </>
        );
    };

    render() {
        const { item } = this.props;

        if (item.url) {
            let target = "_self";
            const url = new URL(item.url);
            if (url.host !== location.host) {
                target = "_blank";
            }

            return (
                <a
                    href={item.url}
                    className="flex flex-col"
                    target={target}
                    title={item.title}
                >
                    {this.renderMain()}
                </a>
            );
        } else {
            return <div className="flex flex-col">{this.renderMain()}</div>;
        }
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Item);
